module.exports = __webpack_public_path__ + "img/duck.cf732df7.svg";